import axios from "fetch-api/fetch-api";
import { ISubscribeNewsletter } from "../interfaces/contact-api.type";

export default function onSubmitSubscriptionEmailModalApi(email: string) {
  return axios.post<ISubscribeNewsletter>("/newsletter-subscribe-v4", { email });
}
